import { render, staticRenderFns } from "./section-header.vue?vue&type=template&id=941ef864&scoped=true"
import script from "./section-header.vue?vue&type=script&lang=js"
export * from "./section-header.vue?vue&type=script&lang=js"
import style0 from "./section-header.vue?vue&type=style&index=0&id=941ef864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941ef864",
  null
  
)

export default component.exports